import React, { Component } from 'react'
import { connect } from 'react-redux'
import actions from 'client/actions'
import UserDialog from 'client/components/UserDialog'

class Users extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isDialogOpen: false,
    }
    this.handleDialog = this.handleDialog.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount () {
    const { dispatch } = this.props
  }

  handleDialog () {
    const { dispatch } = this.props
    this.setState({
      isDialogOpen: !this.state.isDialogOpen
    })
  }

  handleDelete (id) {
        const { dispatch, deleteUser, current } = this.props
        dispatch(deleteUser(current.id, id))
  }

  render () {
    const { current } = this.props
    const { isDialogOpen } = this.state
    return (
      <div>
        <h2 className="text-center">
          Brugere
        </h2>
        <div>
            <button onClick={this.handleDialog} className="btn btn-sm btn-primary mb-30">Opret</button>
        </div>
        {current.users.length ? <table className="table table-striped table-condensed table-hover user-table">
            <thead><tr><td>Email</td><td></td></tr></thead>
            <tbody>
                {current.users.map(u => <tr>
                    <td>{u.email}</td>
                    <td>
                        <button onClick={() => this.handleDelete(u.id)} className="btn btn-sm btn-danger">Slet</button>
                    </td>
                </tr>)}
            </tbody>
        </table> : <div>Ingen brugere</div>}
        <UserDialog handleDialog={this.handleDialog} isDialogOpen={isDialogOpen} current={current} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const hasEditRights =  state.auth.role === 'admin' || (state.auth.role === 'editor' && state.data.plan.current.internal_contact_id === state.auth.userId) || !state.data.plan.current.internal_contact_id
  return {
    current: state.data.plan.current,
    hasEditRights,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteUser: actions.deletePlanUser,
    dispatch,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users)
